module.exports = __webpack_public_path__ + "static/media/splatter.68312536.svg";